class HealthcarebookHomeController {
    $onInit() {
    }
}

export default HealthcarebookHomeController;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/home/home.controller.js
// module id = 627
// module chunks = 0